import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { Preference } from '../../../types/Preference';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const postPreference = async (formData: Preference) => {
  const response = await CustomAxios.post(`preferences`, formData);
  const { data } = response;
  return data;
};

type useCreatePreferenceProps = {
  onSuccessCallback: () => void;
};
export function useCreatePreference({ onSuccessCallback }: useCreatePreferenceProps) {
  return useMutation({
    mutationFn: (formData: Preference) => postPreference(formData),
    onSuccess: () => {
      // call success
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        // let set the query data with bad errored response
        const preference: Preference = err.response.data as Preference;
        queryClient.setQueryData([queryKeys.allPreferences, 'new'], preference);
      }
    },
  });
}
